import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"
import { PrequoteObjectType } from "./types"

export interface GetPrequoteRequest extends Partial<AxiosRequestConfig> {
  params: {
    adultNumber: number
    childNumber: number
    dayCount: number
    endDate: string
    pet: boolean
    petNumber?: number | null
    preQuoteFlag: boolean
    propertyId: string
    startDate: string
    isRequestFromHost: boolean
    isgoogle: boolean
    pmcId: string
    pmsSystem: string
    prequoteRequestId?: string | null
    searchPrice?: string | null
    allInPriceToggle?: boolean
    directIncentive?: boolean
    quoteId?: string | null
    commissionRatePercent?: number | null
  }
}

interface GetPrequoteResponseData extends ResponseData {
  body: PrequoteObjectType
  message: string
  success?: boolean
}

export interface GetPrequoteResponse extends AxiosResponse {
  data: GetPrequoteResponseData
}

export function getPrequoteApi(
  { params }: GetPrequoteRequest,
  axiosInstance: AxiosInstance,
): Promise<GetPrequoteResponse> {
  const url = `/booking/checkout`
  return axiosInstance({
    method: "get",
    params,
    url,
  }) as Promise<GetPrequoteResponse>
}
